module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Death-Of-Stalin-The.cb96b00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Death-Of-Stalin-The.jpg
// module id = YzbP
// module chunks = 0